export function twa(): any {
    return (window as any)?.Telegram?.WebApp;
}

export function haptic(kind: "success" | "error" | "warning" | "impact") {
    const tg = twa();
    const h = tg?.HapticFeedback;
    if (!h) return;
    if (kind === "impact") return h.impactOccurred("medium");
    if (kind === "success") return h.notificationOccurred("success");
    if (kind === "warning") return h.notificationOccurred("warning");
    if (kind === "error") return h.notificationOccurred("error");
}

export function confirmPopup(title: string, message: string): Promise<boolean> {
    const tg = twa();
    return new Promise((resolve) => {
        if (tg?.showPopup) {
            tg.showPopup(
                {
                    title,
                    message,
                    buttons: [
                        { id: "cancel", type: "cancel", text: "Отмена" },
                        { id: "ok", type: "destructive", text: "Подтвердить" }
                    ]
                },
                (id: string) => resolve(id === "ok")
            );
        } else {
            resolve(window.confirm(`${title}\n\n${message}`));
        }
    });
}